/* eslint-disable react/jsx-pascal-case */
import React, { useEffect } from 'react'
import { useQuery } from 'react-query'
import O_SearchBoxJuryo from 'components/3_Organisms/Groups/O_SearchBoxJuryo'
import O_TableJokenSummary from 'components/3_Organisms/Groups/O_TableJokenSummary'
import O_DialogAlert from 'components/3_Organisms/O_DialogAlert'
import { templateLog } from 'utils/logUtil'
import { useHistory } from 'react-router-dom'
import { baseInfo, groupList, select } from 'types/SearchTypes'
import { useClickNohinYmd, useClickTenpo, useClickTokuisaki, useDateDetail, useDetailView, useFetcherJuryo, useJuryoDetail, useShohinDetail, useTenpoDetail, useTokuisakiDetail } from 'hooks/useJuryo'
import { usePageMessage, useLoading, useIsNotDeleteMessage } from 'hooks/usePage'
import { useErrorLogout, useUser } from 'hooks/useLogin'
import { responseJuryo } from 'utils/requestUtil'
import { useSearchedFormat } from 'hooks/useJuryoTable'
import { usePage } from 'hooks/useTable'
import { useMediaQueryContext } from 'MediaQueryProvider'
import O_TableJokenMobileSummary from 'components/3_Organisms/Groups/O_TableJokenMobileSummary'
import O_TableJokenMobileDetail from 'components/3_Organisms/Groups/O_TableJokenMobileDetail'
import { commonMsg } from 'assets/MessageCode'
import O_AddUser from 'components/3_Organisms/Groups/O_AddUser'
import O_AddUserTokui from 'components/3_Organisms/Groups/O_AddUserTokui'

const C_Juryo = (): JSX.Element => {
  useEffect(() => templateLog('C_Juryo'))

  const [searchJoken, fetcher] = useFetcherJuryo()
  const [detailView, _1] = useDetailView()
  const [clickNohinYmd, _2] = useClickNohinYmd()
  const [clickTokuiCd, _3] = useClickTokuisaki()
  const [clickTenCd, _4] = useClickTenpo()
  const [_5, _6, changeNohinYmdFromDetail, changeNohinYmdToDetail] = useDateDetail()
  const [_7, changeTokuisakiCodeDetail] = useTokuisakiDetail()
  const [_8, changeTenpoCodeDetail] = useTenpoDetail()
  const [_9, _10, _11, _12, changeMijuryoCheckDetail, changeJuryoCheckDetail, changeNaiyoCheckDetail, changeKeppinCheckDetail] = useJuryoDetail()
  const [SHOHIN_CD, _] = useShohinDetail()
  const [page, perPage] = usePage()
  const [changePageErrorMessage, deletePageMessage, changeMessage] = usePageMessage()
  const [backLogin] = useErrorLogout(useHistory())
  const [selectList, searchedFormat] = useSearchedFormat()
  const [isNotDeleteMessage, changeIsNotDeleteMessage] = useIsNotDeleteMessage()
  const { isMobileSite } = useMediaQueryContext()
  const [isJapell] = useUser()

  let filterList: responseJuryo[] = []
  useEffect(() => {
    if (detailView) {
      // 明細の検索条件をセット
      changeNohinYmdFromDetail(clickNohinYmd)
      changeNohinYmdToDetail(clickNohinYmd)
      changeTokuisakiCodeDetail({ label: '', value: clickTokuiCd.toString() })
      changeTenpoCodeDetail({ label: '', value: clickTenCd.toString() })
      let mijuryoCheck = false
      let juryoCheck = false
      let naiyoCheck = false
      let keppinCheck = true
      filterList.forEach((r) => {
        if (r.JURYO_KBN === 0) mijuryoCheck = true
        if (r.JURYO_KBN === 1) juryoCheck = true
        if (r.JURYO_KBN === 2) naiyoCheck = true
        if (r.SURYO === r.NOHIN_SURYO) keppinCheck = false
      })
      changeMijuryoCheckDetail(mijuryoCheck)
      changeJuryoCheckDetail(juryoCheck)
      changeNaiyoCheckDetail(naiyoCheck)
      changeKeppinCheckDetail(keppinCheck)
    }
  }, [detailView, filterList])

  // SWR情報の取得
  const { data, refetch, isFetching, isLoading, error } = useQuery(['postJuryoHyoInfo', searchJoken, page, perPage], fetcher)
  const [loding, changeLoading] = useLoading()
  useEffect(() => {
    if (isLoading || isFetching) {
      changeLoading(true)
    } else {
      if (loding) {
        changeLoading(false)
      }
    }
  }, [isLoading, isFetching])
  useEffect(() => {
    if (isLoading || isFetching) {
      if (!isNotDeleteMessage) deletePageMessage()
    } else {
      if (isNotDeleteMessage) changeIsNotDeleteMessage(false)
    }
  }, [isLoading, isFetching])

  if (isLoading || isFetching || data == undefined) {
    if (selectList.length > 0) searchedFormat()
    return <div>Loading...</div>
  }
  if (error) {
    backLogin()
    changePageErrorMessage(commonMsg.ERROR_MSG)
    return <></>
  }
  const info = data.body
  if (data.message) changeMessage(data)

  const groupList = detailView
    ? []
    : info.table.reduce((prev: groupList[], curr) => {
        const group = prev.filter((r) => {
          return r.NOHIN_YMD === curr.NOHIN_YMD && r.TOKUI_CD === curr.TOKUI_CD && r.TEN_CD === curr.TEN_CD
        })
        if (group.length > 0) {
          // すでにグループデータがある場合
          // 受領区分を更新
          if (curr.JURYO_KBN === 2) {
            if (
              [0, 1, 11].some((r) => {
                return r === group[0].JURYO_KBN
              })
            )
              group[0].JURYO_KBN = 12
          }
          if (curr.JURYO_KBN === 1) {
            if (group[0].JURYO_KBN === 2) group[0].JURYO_KBN = 12
            if (group[0].JURYO_KBN === 0) group[0].JURYO_KBN = 11
          }
          if (curr.JURYO_KBN === 0) {
            if (group[0].JURYO_KBN === 2) group[0].JURYO_KBN = 12
            if (group[0].JURYO_KBN === 1) group[0].JURYO_KBN = 11
          }

          // 連携区分を更新
          if (group[0].RENKEI_KBN === 1 && curr.RENKEI_KBN === 0) group[0].RENKEI_KBN = 0

          return prev
        } else {
          // ない場合
          const group = {
            JURYO_KBN: curr.JURYO_KBN,
            RENKEI_KBN: curr.RENKEI_KBN,
            NOHIN_YMD: curr.NOHIN_YMD,
            TOKUI_CD: curr.TOKUI_CD,
            TOKUI_NM: curr.TOKUI_NM,
            TEN_CD: curr.TEN_CD,
            TEN_NM: curr.TEN_NM,
          }

          return [...prev, group]
        }
      }, [])

  groupList.sort((a, b) => {
    if (a.TOKUI_CD < b.TOKUI_CD) {
      return -1
    } else if (a.TOKUI_CD > b.TOKUI_CD) {
      return 1
    }
    if (a.TEN_CD < b.TEN_CD) {
      return -1
    } else if (a.TEN_CD > b.TEN_CD) {
      return 1
    }
    if (a.NOHIN_YMD < b.NOHIN_YMD) {
      return -1
    } else if (a.NOHIN_YMD > b.NOHIN_YMD) {
      return 1
    }

    return 0
  })
  filterList = !detailView
    ? []
    : info.table.filter((r) => {
        const isClickData = clickNohinYmd === r.NOHIN_YMD && clickTokuiCd === r.TOKUI_CD && clickTenCd === r.TEN_CD
        // クリックしたサマリデータと一致しない場合
        if (!isClickData) return false

        if (SHOHIN_CD === '-1') {
          // 商品プルダウンを選択していない場合
          return true
        } else {
          // 商品プルダウンを選択している場合
          return Number(SHOHIN_CD) === r.SHOHIN_CD
        }
      })

  filterList.sort((a, b) => {
    if (a.JCU_KBN < b.JCU_KBN) {
      return -1
    } else if (a.JCU_KBN > b.JCU_KBN) {
      return 1
    }
    if (Number(a.DENPYO_NO) < Number(b.DENPYO_NO)) {
      return -1
    } else if (Number(a.DENPYO_NO) > Number(b.DENPYO_NO)) {
      return 1
    }
    if (a.GYO_NO < b.GYO_NO) {
      return -1
    } else if (a.GYO_NO > b.GYO_NO) {
      return 1
    }
    return 0
  })
  const pullDown: baseInfo = { ...info.pullDown }
  if (detailView) {
    // 明細表示の場合、商品プルダウンをサマリ画面で押下したデータの商品のみにする
    const shohinList: select[] = []
    info.pullDown.shohinList!.forEach((r) => {
      if (r) {
        if (r.value === '-1') {
          shohinList.push(r)
        } else {
          const isSummaryShohin = filterList.some((r2) => {
            return r2.SHOHIN_CD === Number(r.value)
          })
          const isPush = shohinList.some((r2) => {
            return r2 && r2.value === r.value
          })
          // クリックしたサマリに含まれる商品、かつまだプルダウンに入れていない場合
          if (isSummaryShohin && !isPush) shohinList.push(r)
        }
      }
    })
    pullDown.shohinList = shohinList
  }

  return (
    <>
      <O_SearchBoxJuryo info={pullDown} />
      <hr />
      {!isMobileSite ? <O_TableJokenSummary jokenList={info.table} isFetching={isFetching} refetch={refetch} allCount={info.allCount} csvInfo={info.csvInfo} /> : !detailView ? <O_TableJokenMobileSummary groupList={groupList} /> : <></>}
      {isMobileSite && detailView ? <O_TableJokenMobileDetail filterList={filterList} refetch={refetch} /> : <></>}
      {/* アラートダイアログ */}
      <O_DialogAlert />
      {/* アラートダイアログ */}
      {isJapell ? <O_AddUser refetch={refetch} /> : <O_AddUserTokui refetch={() => {}} />}
    </>
  )
}

export default React.memo(C_Juryo)
